export const UPGRADE_URL = "https://calebmpeterson.gumroad.com/l/calcula";
